module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-571.e7c3322.woff2";